<template>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            {{ $t('debtors.index') }}
          </div>
          <div class="card-body">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Поиск по ФИО" v-model="fullname" @keyup="search">
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Поиск по ИИН" v-model="iin" @keyup="search">
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Поиск по ДБЗ" v-model="number" @keyup="search">
            </div>
            <draggable v-if="!loadDebt" tag="span" v-model="debts" v-bind="getOptions()" :move="addDebt" @start="isDragging=true" @end="isDragging=false">
              <transition-group class="list-group" tag="ul">
                <li class="list-group-item" v-for="(debt, index) in debts" :key="debt.id">
                  {{debt.debtor.fullname}}
                  <button class="btn btn-link float-right toggle p-0" @click.prevent="initViewDebt(index)" data-toggle="tooltip" data-placement="top" title="Посмотреть">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </li>
              </transition-group>
            </draggable>
            <div v-if="loadDebt" class="text-center">
              <loader-wave/>
            </div>
          </div>
          <div class="card-footer">
            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="3" @paginate="fetchDebts()" />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            {{ $t('users.debts') }} ({{user_debts.length}})
          </div>
          <div class="card-body">
            <draggable v-if="!loadUserDebt" tag="span" v-model="user_debts" v-bind="getOptions()" :move="removeDebt">
              <transition-group name="no" class="list-group" tag="ul">
                <li class="list-group-item" v-for="(user_debt, index) in user_debts" :key="user_debt.id">
                  {{user_debt.debtor.lastname}} {{user_debt.debtor.firstname}} {{user_debt.debtor.middlename}}
                  <button class="btn btn-link float-right toggle p-0" @click.prevent="initViewUserDebt(index)" data-toggle="tooltip" data-placement="top" title="Посмотреть">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </li>
              </transition-group>
            </draggable>
            <div v-if="loadUserDebt" class="text-center">
              <loader-wave/>
            </div>
          </div>
        </div>
      </div>

      <b-modal size="lg" title="Задолжник" ref="modalViewUserDebt">
          <div class="form-group row">
            <div class="col">
              <h4>
                {{viewDebt.debtor.lastname}} {{viewDebt.debtor.firstname}} {{viewDebt.debtor.middlename}}
                <a :href="'/admin/debtors/' + viewDebt.debtor.id" target="_blank"><i class="fa fa-share-square-o" aria-hidden="true"></i></a>
              </h4>
              <h6 class="badge badge-pill badge-primary" v-if="viewDebt.status">{{viewDebt.status.name}}</h6>
            </div>
          </div>
          <div class="form-group row">
            <div class="col">
              <label class="col-form-label">{{ $t('debts.number') }}</label>
              <h5>{{viewDebt.number}}</h5>
            </div>

          </div>
          <div class="form-group row">
            <div class="col">
              <label class="col-form-label">{{ $t('debts.current_arrears') }}</label>
              <h5>{{viewDebt.current_arrears}} тг</h5>
            </div>
            <div class="col">
              <label class="col-form-label">{{ $t('debts.contragent') }}</label>
              <h5>{{viewDebt.contragent ? viewDebt.contragent.name : ''}}</h5>
            </div>
            <div class="col">
              <label class="col-form-label">{{ $t('debts.amount_credit') }}</label>
              <h5>{{viewDebt.amount_credit}} тг</h5>
            </div>
          </div>
          <div class="form-group row">
            <div class="col">
              <label class="col-form-label">{{ $t('debts.start_date') }}</label>
              <h5>{{viewDebt.start_date| dateFormat }}</h5>
            </div>
            <div class="col">
              <label class="col-form-label">{{ $t('debts.end_date') }}</label>
              <h5>{{viewDebt.end_date| dateFormat }}</h5>
            </div>
            <div class="col">
              <label class="col-form-label">{{ $t('debts.delay_credit_day') }}</label>
              <h5>{{viewDebt.delay_credit_day}}</h5>
            </div>
          </div>
      </b-modal>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  props: [
    'userId',
  ],
  components: {
    draggable,
  },
  data() {
    return {
      debts: [],
      user_debts: [],
      viewDebt: {
        debtor: '',
        contragent: '',
      },
      isDragging: false,
      delayedDragging: false,
      pagination: {
        current_page: 1,
      },
      fullname: '',
      iin: '',
      number: '',
      loadDebt: false,
      loadUserDebt: false,
    };
  },
  mounted() {
    this.fetchDebts();
    this.fetchUserDebts();
  },
  methods: {
    addDebt({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      window.axios.put(`/admin/debts/adduser/${draggedElement.id}`, { userid: this.$route.params.id })
        .then(res => res.status === 201)
        .catch(() => false);
    },

    removeDebt({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      window.axios.put(`/admin/debts/removeuser/${draggedElement.id}`, { userid: this.$route.params.id })
        .then(res => res.status === 201)
        .catch(() => false);
    },

    fetchDebts() {
      this.loadDebt = true;
      window.axios.get(`/admin/debts/notassigned?page=${this.pagination.current_page}`)
        .then((res) => {
          this.debts = res.data.debts.data;
          this.pagination = this.laraPaginate(res.data.debts);
        })
        .finally(() => {
          this.loadDebt = false;
        });
    },

    searchDebts() {
      this.loadDebt = true;
      window.axios.post(`/admin/debts/search?page=${this.pagination.current_page}`, {
        fullname: this.fullname,
        iin: this.iin,
        number: this.number,
      })
        .then((res) => {
          this.debts = res.data.debts.data;
          this.pagination = this.laraPaginate(res.data.debts);
        })
        .finally(() => {
          this.loadDebt = false;
        });
    },

    fetchUserDebts() {
      this.loadUserDebt = true;
      window.axios.get(`/admin/users/${this.$route.params.id}/debts`)
        .then((res) => {
          this.user_debts = res.data.debts;
        })
        .finally(() => {
          this.loadUserDebt = false;
        });
    },

    search() {
      if (this.fullname.length >= 3 || this.iin.length >= 3 || this.number.length >= 3) {
        this.searchDebts();
      } else if (this.fullname.length === 0) {
        this.fetchDebts();
      }
    },

    initViewDebt(index) {
      this.$refs.modalViewUserDebt.show();
      this.viewDebt = this.debts[index];
      this.viewDebt.debtor = this.debts[index].debtor;
      this.viewDebt.contragent = this.debts[index].contragent;
    },
    initViewUserDebt(index) {
      this.$refs.modalViewUserDebt.show();
      this.viewDebt = this.user_debts[index];
      this.viewDebt.debtor = this.user_debts[index].debtor;
      this.viewDebt.contragent = this.user_debts[index].contragent;
    },
    getOptions() {
      return {
        animation: 0,
        group: 'description',
        ghostClass: 'ghost',
      };
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
};
</script>

<style lang="css">
  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    min-height: 20px;
  }

  .list-group-item {
    cursor: move;
  }

  .list-group-item i {
    cursor: pointer;
  }
</style>
